import request from '@/utils/request'
/*权限*/
let ChannelApi = {
    // 渠道用户列表
  userlist(data, errorback) {
    return request._post('/shop/channel.user/userlist', data, errorback);
  },
  // 订单列表
  orderList(data, errorback) {
    return request._post('/shop/channel.user/orderList', data, errorback);
  },
  // 代理详情
  channel(data, errorback) {
    return request._post('/shop/channel.user/channel', data, errorback);
  }

}
export default ChannelApi;



// WEBPACK FOOTER //
// ./src/api/channel.js